<mat-form-field class="pv-chip-list">
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #chipGrid >
    <mat-chip-row *ngFor="let tag of tags"
                  (removed)="remove(tag)"
                  [editable]="true">
      {{displayWith(tag)}}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip-row>
    <input
      [placeholder]="placeholder"
      #tagInput
      [formControl]="inputCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)">
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <ng-container *ngIf="hasAutocomplete">
      <mat-option *ngFor="let item of filteredItems | async" [value]="item">
        {{ displayWith(item) }}
      </mat-option>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>